export default __webpack_public_path__ + "static/media/flag-south-korea.8ea0113e.svg";